// import React, { useState } from "react";
// import {
//     Box,
//     IconButton,
//     List,
//     ListItem,
//     ListItemButton,
//     ListItemIcon,
//     ListItemText,
//     Drawer,
//     useMediaQuery,
//     useTheme,
// } from "@mui/material";
// import { useNavigate, useLocation } from "react-router-dom";

// import MenuIcon from "@mui/icons-material/Menu";
// import {
//     Home as HomeIcon,
//     ReceiptLong as ReceiptIcon,
// } from "@mui/icons-material";

// // 🔹 Menu Items Array
// const menuItems = [
//     { text: "Home", icon: <HomeIcon />, route: "/" },
//     { text: "Pooja Telecast", icon: <HomeIcon />, route: "/telecast" },
//     { text: "Donations Module", icon: <HomeIcon />, route: "/donations" },
//     { text: "News & Announcements", icon: <HomeIcon />, route: "/news" },
//     { text: "Events & Push Notifications", icon: <HomeIcon />, route: "/events" },
//     { text: "Booking Services", icon: <HomeIcon />, route: "/bookings" },
//     { text: "User Management", icon: <HomeIcon />, route: "/" },
//     { text: "Settings", icon: <HomeIcon />, route: "/" },
// ];

// const Mainsidebar = () => {
//     const [open, setOpen] = useState(false);
//     const navigate = useNavigate();
//     const location = useLocation();
//     const theme = useTheme();
//     const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

//     return (
//         <>
//             {/* 🟢 Toggle Menu Button - FIXED POSITION */}
//             <Box
//                 sx={{
//                     position: "fixed",
//                     top: isMobile ? 16 : 88,
//                     left: isMobile ? 16 : 70,
//                     zIndex: 1500,
//                 }}
//                 className="side-data-bar"
//             >
//                 <IconButton onClick={() => setOpen(!open)} sx={{ color: "#7564e6ff" }}>
//                     <MenuIcon fontSize="large" />
//                 </IconButton>
//             </Box>

//             {/* 🟣 Sidebar Drawer */}
//             <Drawer
//                 anchor="left"
//                 variant="temporary"
//                 open={open}
//                 onClose={() => setOpen(false)}
//                 ModalProps={{
//                     BackdropProps: { invisible: true }, // ✅ NO OVERLAY
//                 }}
//                 PaperProps={{
//                     sx: {
//                         marginTop: isMobile ? "56px" : "80px",
//                         height: isMobile ? "calc(100vh - 56px)" : "calc(100vh - 80px)",
//                         width: 200,
//                         backgroundColor: "transparent",
//                         boxShadow: "none",
//                     },
//                 }}
//             >
//                 <List sx={{
//                     marginTop: isMobile ? "16px" : "52px",
//                     padding: "0 5px",
//                     background: "transparent",
//                 }}>
//                     {menuItems.map((item, index) => (
//                         <ListItem key={index} disablePadding>
//                             <ListItemButton
//                                 sx={{
//                                     background: location.pathname === item.route ? "#7564e6ff" : "#7564e6ff",
//                                     borderRadius: "20px",
//                                     marginBottom: "10px",
//                                     color: "#fff",
//                                     "&:hover": { background: "#389ae4ff" },
//                                 }}
//                                 onClick={() => {
//                                     navigate(item.route);
//                                     setOpen(false);
//                                 }}
//                             >
//                                 <ListItemIcon sx={{ color: "#fff", minWidth: "27px" }}>
//                                     {item.icon}
//                                 </ListItemIcon>
//                                 <ListItemText
//                                     primary={item.text}
//                                     primaryTypographyProps={{
//                                         style: { fontSize: "12px", fontWeight: "bold" },
//                                     }}
//                                 />
//                             </ListItemButton>
//                         </ListItem>
//                     ))}
//                 </List>
//             </Drawer>
//         </>
//     );
// };

// export default Mainsidebar;


import React, { useState, useEffect } from "react";
import {
    Box,
    IconButton,
    List,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Drawer,
    useMediaQuery,
    useTheme,
} from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";

import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import LogoutIcon from "@mui/icons-material/Logout";
import SettingsIcon from "@mui/icons-material/Settings";
import {
    Home as HomeIcon,
    Business as BusinessIcon,
    MenuBook as MenuBookIcon,
    AccountCircle as AccountCircleIcon,
    Work as WorkIcon,
    CalendarToday as CalendarTodayIcon,
    Payments as PaymentsIcon,
    ConfirmationNumber as ConfirmationNumberIcon,
    Dashboard as DashboardIcon,
    Email as EmailIcon,
    FileCopy as FileCopyIcon,
    People as PeopleIcon,
    Assessment as AssessmentIcon,
    Security as SecurityIcon,
    Help as HelpIcon,
} from "@mui/icons-material";

// 🔹 Menu Items Array
const menuItems = [
    { text: "HOME", icon: <HomeIcon />, route: "/Userdashbord" },
    { text: "COMPANY", icon: <BusinessIcon />, route: "/Usercompany" },
    { text: "DIRECTORY", icon: <MenuBookIcon />, route: "/Directeory" },
    { text: "PROFILE", icon: <AccountCircleIcon />, route: "/userhome" },
    { text: "PROFESSIONAL", icon: <WorkIcon />, route: "/professional" },
    { text: "ATTENDANCE", icon: <CalendarTodayIcon />, route: "/attendance" },
    { text: "PAY ROLL", icon: <PaymentsIcon />, route: "/Payroll" },
    { text: "TICKETING", icon: <ConfirmationNumberIcon />, route: "/Tickting" },
  
];


// 🔹 Bottom Menu Items
const bottomMenuItems = [
    { text: "Logout", icon: <LogoutIcon />, route: "/logout" },
    { text: "nepalweb.com", icon: <HomeIcon />, route: "https://nepalweb.com", external: true },
    { text: "Settings", icon: <SettingsIcon />, route: "/settings" },
];

const Mainsidebar = () => {
  const [open, setOpen] = useState(false);
  const [isDesktop, setIsDesktop] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();

  /* 🔥 MAIN FIX: 1200px BREAKPOINT */
  const isMobile = useMediaQuery(theme.breakpoints.down("lg")); // <1200 = mobile

  useEffect(() => {
    setIsDesktop(!isMobile);

    if (!isMobile) {
      setOpen(true); // desktop sidebar always open
    } else {
      setOpen(false); // mobile closed by default
    }
  }, [isMobile]);

  const handleNavigation = (item) => {
    navigate(item.route);
    if (isMobile) setOpen(false);
  };

  return (
    <>
      {/* ================= MOBILE MENU BUTTON ================= */}
      {isMobile && (
        <Box
          sx={{
            position: "fixed",
            top: 70,
            left: 10,
            zIndex: 1500,
          }}
        >
          <IconButton
            onClick={() => setOpen(!open)}
            sx={{
              width: 38,
              height: 38,
              color: "#7564e6",
              transition: "0.3s",
              transform: open ? "rotate(90deg)" : "rotate(0deg)",
              "& svg": { fontSize: 22 },
            }}
          >
            {open ? <CloseIcon /> : <MenuIcon />}
          </IconButton>
        </Box>
      )}

      {/* ================= DESKTOP SIDEBAR (>=1200px) ================= */}
      {isDesktop && (
        <Box
          sx={{
            position: "fixed",
            left: 0,
            top: 75,
            width: 240,
            height: "calc(100vh - 75px)",
            background: "#f8fafc",
            borderRight: "1px solid #e2e8f0",
            zIndex: 1000,
            display: "flex",
            flexDirection: "column",
          }}
        >
          {/* LOGO */}
          <Box
            sx={{
              py: 3,
              textAlign: "center",
              borderBottom: "1px solid #e2e8f0",
            }}
          >
            <h2 style={{ margin: 0, color: "#7564e6" }}>Envision</h2>
          </Box>

          {/* MENU */}
          <List sx={{ px: 1, py: 2, flexGrow: 1 }}>
            {menuItems.map((item, i) => {
              const active = location.pathname === item.route;
              return (
                <ListItem key={i} disablePadding sx={{ mb: 0.5 }}>
                  <ListItemButton
                    onClick={() => handleNavigation(item)}
                    sx={{
                      borderRadius: 2,
                      bgcolor: active ? "#7564e6" : "transparent",
                      color: active ? "#fff" : "#475569",
                      "&:hover": {
                        bgcolor: active ? "#7564e6" : "#f1f5f9",
                      },
                    }}
                  >
                    <ListItemIcon
                      sx={{
                        color: active ? "#fff" : "#64748b",
                        minWidth: 36,
                      }}
                    >
                      {item.icon}
                    </ListItemIcon>
                    <ListItemText primary={item.text} />
                  </ListItemButton>
                </ListItem>
              );
            })}
          </List>
        </Box>
      )}

      {/* ================= MOBILE DRAWER (<1200px) ================= */}
      <Drawer
        anchor="left"
        open={open && isMobile}
        onClose={() => setOpen(false)}
        PaperProps={{
          sx: {
            width: 280,
            background: "#f8fafc",
          },
        }}
      >
        {/* HEADER */}
        <Box
          sx={{
            p: 3,
            background: "#7564e6",
            color: "#fff",
          }}
        >
          <h2 style={{ margin: 0 }}>Envision</h2>
        </Box>

        {/* MENU */}
        <List sx={{ p: 2 }}>
          {menuItems.map((item, i) => {
            const active = location.pathname === item.route;
            return (
              <ListItem key={i} disablePadding sx={{ mb: 1 }}>
                <ListItemButton
                  onClick={() => handleNavigation(item)}
                  sx={{
                    borderRadius: 2,
                    bgcolor: active ? "#7564e6" : "transparent",
                    color: active ? "#fff" : "#475569",
                  }}
                >
                  <ListItemIcon
                    sx={{
                      color: active ? "#fff" : "#64748b",
                      minWidth: 36,
                    }}
                  >
                    {item.icon}
                  </ListItemIcon>
                  <ListItemText primary={item.text} />
                </ListItemButton>
              </ListItem>
            );
          })}
        </List>
      </Drawer>

      {/* SPACER FOR DESKTOP CONTENT */}
      {isDesktop && <Box sx={{ width: 240 }} />}
    </>
  );
};

export default Mainsidebar;




